module.exports = __webpack_public_path__ + "img/nexultra-p-icon.1fdc93f8.svg";